const KEY = 'fb:runlog';
const MAX = 500;
const listeners = new Set();
let records = read();
function read() {
    try {
        return JSON.parse(localStorage.getItem(KEY) ?? '[]');
    }
    catch {
        return [];
    }
}
function persist() {
    try {
        localStorage.setItem(KEY, JSON.stringify(records));
    }
    catch {
        /* storage full / blocked – keep in memory */
    }
    listeners.forEach((l) => l());
}
export function logRun(r) {
    records = [{ ts: Date.now(), ...r }, ...records].slice(0, MAX);
    persist();
}
export function clearRuns() {
    records = [];
    persist();
}
export const getRuns = () => records;
export function subscribeRuns(listener) {
    listeners.add(listener);
    return () => void listeners.delete(listener);
}
//# sourceMappingURL=runlog.js.map